import { TRACKING_OPERATION } from '@/utils/constants';
import { chatbotTrackObj } from '..';

export function redirectTrack(params?: any) {
  return chatbotTrackObj.report({
    operation: TRACKING_OPERATION.REDIRECT,
    data: params,
  });
}
